<div class="content"
     [matTooltip]="tooltip"
     matTooltipClass="tooltip"
     ellipsis>
  <ng-content></ng-content>
</div>
